var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChlorinationTank = function SvgChlorinationTank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 23h14v-2H9zM9 21h2v-8H9zM21 19h2v-8h-2zM13 19h2v-8h-2zM17 21h2v-8h-2zM9 11h14V9H9z"
  })));
};
export { SvgChlorinationTank as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M9 23H23V21H9V23Z' fill='%234A6067'/%3e %3cpath d='M9 21H11V13H9V21Z' fill='%234A6067'/%3e %3cpath d='M21 19H23V11H21V19Z' fill='%234A6067'/%3e %3cpath d='M13 19H15V11H13V19Z' fill='%234A6067'/%3e %3cpath d='M17 21H19V13H17V21Z' fill='%234A6067'/%3e %3cpath d='M9 11H23V9L9 9V11Z' fill='%234A6067'/%3e %3c/svg%3e";